export default __webpack_public_path__ + "static/media/chocolate-cake.c4e93875.jpg";